<div class="loader-container">
    <!-- <h1 *ngIf="(inventoryLoadedPercent$ | async) && (inventoryLoadedPercent$ | async) > 0">
      Loaded {{(inventoryLoadedPercent$ | async) ? (inventoryLoadedPercent$ | async) : "--" }} %
    </h1> -->
    <div class="loader-background"></div>
    <div class="loader" [ngClass]="{'!p-2': !expanded}">

        <div [ngClass]="{'closed' : !expanded}">
            <img src="assets/gifs/pill.gif" class="pill-gif" (click)="navigateToBulkAdd()">
            <span *ngIf="(inventoryLoadedPercent$ | async)" class="progress">Loaded {{(inventoryLoadedPercent$ | async)}}%</span>
            <div (click)="onExpandCollapse()" *ngIf="!expanded" class="hidden-area-to-expand"></div>
        </div>
        <div class="header-container flex flex-row" *ngIf="expanded" (click)="onExpandCollapse()">
            <div>
                <div class="header">{{header}}
                    <img src="assets/icons/icon-chevron-down-gray.svg ">
                </div>
                <div class="sub-header" (click)="navigateToBulkAdd()">
                  This could take a few minutes but<br/>
                  feel free to use the rest of the system<br/>
                  and we'll keep the progress.
                </div>
            </div>
        </div>
    </div>
</div>
